import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {VetClinic, VetClinicPhotoGalleryImage, VetDoctor, VImage} from "../../models/vet-clinic.model";
import {EMPTY, Subscription} from "rxjs";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {VetClinicInfoData} from "../../models/vet-clinic-info-data.model";
import {User} from "../../models/user.model";
import {Client} from "../../models/client.model";
import {VisitType} from "../../models/vet-clinic-data.model";
import {AppStateService} from "../../providers/app-state.service";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {CommonUtils} from "../../utils/common";
import {FileService} from "../../providers/file.service";
import {InputChangeEventDetail, ItemReorderEventDetail, ModalController} from "@ionic/angular";
import {UserService} from "../../providers/user.service";
import {ClientsService} from "../../providers/clients.service";
import {UnsavedChangesGuard} from "../../providers/unsaved-changes.guard";
import {timeValidator} from "../../utils/form-validators";
import {VImageDropComponent} from "../v-image-drop/v-image-drop.component";
import {
  SelectSmsCrmModuleExpirationDateComponent
} from "../select-sms-crm-module-expiration-date/select-sms-crm-module-expiration-date.component";
import {GenericSelectDateComponent} from "../generic-select-date/generic-select-date.component";
import {VetClinicPetSpeciesService} from "../../providers/vet-clinic-pet-species.service";
import {VetClinicPetSpecies} from "../../models/vet-clinic-pet-species.model";
import {SelectSpeciesModalComponent} from "../select-species-modal/select-species-modal.component";
import {PetSpeciesGroup} from "../../models/pet-species-group.model";
import {finalize, switchMap, tap} from "rxjs/operators";

@Component({
  selector: 'app-clinic-advanced-settings',
  templateUrl: './clinic-advanced-settings.component.html',
  styleUrls: ['./clinic-advanced-settings.component.scss'],
})
export class ClinicAdvancedSettingsComponent implements OnInit, OnDestroy {
  @Input()
  vetClinic: VetClinic;
  isBusySub: Subscription;
  @Output()
  vetClinicEditedEmitter: EventEmitter<VetClinic> = new EventEmitter<VetClinic>();
  @Output()
  cancelVetClinicEditedEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  hasUnsavedChangesEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  vetClinicGroup: FormGroup;

  vetClinicInfoData: VetClinicInfoData;

  servicesItems: string[];
  services: string[];

  vImages: VImage[];
  vImagesSub: Subscription;

  partnerAction: string;

  hasUnsavedChanges: boolean = false;
  advancedSettingsOpened: boolean = false;

  isAdmin: boolean;
  isGeneralAdmin: boolean;
  loggedUser: User;
  partners: Client[];
  partnerUUID: string;
  partner: Client;
  partnerToChange: Client;
  images: VImage[];
  vc: VetClinic;
  linkedReservationDoctors: VetDoctor[];
  addPartner: boolean;
  selectedGVisitType: any;
  vTypes: VisitType[] = [];
  isBusy: boolean;
  paymentsEnabled: boolean;
  messagesEnabled: boolean;
  useBookingHoursForCheckHoursList: boolean;

  voucherInfoFirstInSubject: boolean;
  vetClinicGallery: VImage[] | VetClinicPhotoGalleryImage[];
  vrAutoLockMode: boolean;
  vrAutoLockEndHour: string;
  isOldRecommendationsSyncBlocked: boolean;
  isOldLabTestDataBlocked: boolean;
  isSendExtendedNotifications: boolean;
  sendVisitTypeAdditionalInfo: boolean;

  visitSyncHourMode: boolean = false;
  visitSyncHour: string;
  startSyncDate: string;
  reservationCancellationRefund: number;
  paymentLinkAppointmentsQueryDays: number = 2;
  maxReservationCancellation: string;
  legalVersion: boolean;
  visitUpdateSyncPushBlock: boolean;
  visitUpdateSyncPushBlockAfter: boolean;
  visitUpdateSyncPushBlockValue: any;
  visitUpdateSyncPushBlockValueAfter: any;
  pushBlockValueRegex: RegExp = new RegExp(/^[1-8]$/);
  simpleNumberRegexp: RegExp = new RegExp(/^[1-9]|[1-9]\d+$/);
  numberRegexp: RegExp = new RegExp(/^\d+$/);
  private alertPresented: boolean = false;
  showAllFreeTerms: boolean;
  disableCheckKlinikaXpSync: boolean;
  markInvoicesIssuedToReceipt: boolean;
  vetineoLicenceKey: string;
  vetineoLicenceKeyExpirationDate: Date;
  blockReservationsBeforeHour: number;
  blockReservationsAfterHour: number;
  subscriptions: Subscription = new Subscription();
  blockReservationsNotInWorkHours: boolean;
  hours: number[];
  blockReservationsNotInWorkHoursWasSet: boolean = false;
  isGeneralClinicAdmin: boolean;
  delayLabTestDataAcceptationSync: boolean;
  labTestDataAcceptationSyncDelayInHours: number;
  labTestDataDuringPreparationText: string;
  reservationCalendarDaySize: number;
  calendarDaysValues: number[] = [];
  smsModuleExpiration: any;
  sendEmailAboutCrmSmsModuleExpiration: boolean;
  isOffline: boolean;
  vetineoStartDate: any;
  allSpecies: boolean = true;
  species: VetClinicPetSpecies[] = [];
  petSpecies: VetClinicPetSpecies[] = [];
  private tempSpecies: any;
  isAvailableOnMap: boolean;
  daysForLinks: number[] = [];
  addCancellationHoursToMail: boolean;
  useDifferentVisitTypeTimeInKlinikaXp: boolean;
  delayReservationFromClinic: number;
  delayPrepaidReservationFromClinic: number;
  petSpeciesGroups: PetSpeciesGroup[];
  groupedSpecies: { group: PetSpeciesGroup; species: VetClinicPetSpecies[] }[];

  constructor(private appStateService: AppStateService, private vetClinicService: VetClinicService
    , private commonUtils: CommonUtils, private formBuilder: FormBuilder, private fileService: FileService, private modalController: ModalController,
              private userService: UserService, private clientsService: ClientsService,
              private unsavedChangesGuard: UnsavedChangesGuard, private vetClinicPetSpeciesService: VetClinicPetSpeciesService) {
  }

  getSpecies() {
    return this.species;
  }


  comparePets(o1, o2) {
    return o1 && o2 ? o1.key == o2.key : false;
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  numericOnly(event): boolean {
    const pattern = /^([0-9])$/;
    const result = pattern.test(event.key);
    return result;
  }

  isHour(str: string) {
    const pattern = /^[0-9]{2}:[0-9]{2}$/;
    const result = pattern.test(str);
    return result;
  }

  ngOnInit() {
    this.vetClinicGallery = [];
    this.vetClinicGallery = this.vetClinic.gallery?.map((i) => i);

    for (let i = 21; i < 91 ; i++) {
      this.calendarDaysValues.push(i);
    }

    if (!this.vetClinic.servedPetSpeciesKeys || this.vetClinic.servedPetSpeciesKeys === '[]') {
      this.allSpecies = true;
    } else {
      this.allSpecies = false;
    }

    this.appStateService.updateIsBusySubject(true);
    this.registerSubscription(
      this.vetClinicPetSpeciesService.getGlobalSpecies().pipe(
        tap(species => {
          if (species) {
            this.species = species;
            if (this.vetClinic.servedPetSpeciesKeys && this.species) {

              const servedPetSpecies: string[] = JSON.parse(this.vetClinic.servedPetSpeciesKeys);
              if (servedPetSpecies && servedPetSpecies.length > 0) {
                this.allSpecies = false;
              }
              this.petSpecies = servedPetSpecies.map(e => (species.filter(s => s.key === e)[0]) as VetClinicPetSpecies) as VetClinicPetSpecies[];
            }
          }
        }),
        switchMap(species => {
          return species ? this.vetClinicPetSpeciesService.getGlobalSpeciesGroups() : EMPTY;
        }),
        tap(groups => {
          if (groups) {
            this.petSpeciesGroups = groups;
            this.groupedSpecies = this.groupSpecies();
          }
        }),
        finalize(() => this.appStateService.updateIsBusySubject(false))
      ).subscribe()
    );

    this.partnerAction = 'przypisz partnera';
    this.appStateService.updateIsBusySubject(true);
    this.userService.getUser().subscribe(u => {
        if (u !== null) {
          this.loggedUser = u;
          this.isAdmin = u.roles?.split(';').filter(e => e === 'admin').length === 1;
          this.isGeneralAdmin = this.isAdmin && u.vClientId === null && u.vetcodeId === null;
          this.isGeneralClinicAdmin = u.vClientId === null && u.vetcodeId === null;
          if (this.isGeneralAdmin || this.isGeneralClinicAdmin) {
            this.clientsService.listAllPartners().subscribe(p => {
              if (p) {
                this.partners = p;
                this.partner = this.partners?.filter(e => e.id === this.vetClinic?.partnerVClientId)[0];
              }
            })
          }
          this.appStateService.updateIsBusySubject(false);

        }
      }
    );

    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
      if (isBusy) {
        if (this.vetClinicGroup) {
          this.vetClinicGroup.disable();
        }
      } else {
        if (this.vetClinicGroup) {
          this.vetClinicGroup.enable();
        }
      }
    });

    // console.log(e);
    this.vTypes = this.vetClinic.visitTypes;
    this.selectedGVisitType = 'all-types';

    this.voucherInfoFirstInSubject = this.vetClinic.voucherInfoFirstInSubject;
    this.paymentsEnabled = this.vetClinic.paymentsEnabled;
    this.messagesEnabled = this.vetClinic.messagesEnabled;
    this.vrAutoLockMode = this.vetClinic?.vrAutoLockMode === 1;
    this.vrAutoLockEndHour = this.vetClinic.vrAutoLockEndHour;
    this.delayPrepaidReservationFromClinic = this.vetClinic.delayPrepaidReservationFromClinic;
    this.delayReservationFromClinic = this.vetClinic.delayReservationFromClinic;

    this.vetClinic.visitTypes.forEach(visitType => {
      let vetVisitType = this.vetClinic?.vetVisitTypes?.filter(e => e.klinikaXpVisitId === visitType.xid)[0];
      if (vetVisitType === undefined) {
        return visitType;
      } else {
        visitType.prepaidPrice = vetVisitType?.prepaidPrice
        visitType.online = vetVisitType?.online
        visitType.prepaidRequired = vetVisitType?.prepaidRequired
        return visitType
      }
    })

    if (this.vetClinic.reservationCalendarDaySize) {
      this.reservationCalendarDaySize = this.vetClinic.reservationCalendarDaySize;

    } else {
      this.reservationCalendarDaySize = 21;
    }

    this.useDifferentVisitTypeTimeInKlinikaXp = this.vetClinic.useDifferentVisitTypeTimeInKlinikaXp;

    this.isOffline = this.vetClinic.isOffline;
    this.isAvailableOnMap = this.vetClinic.isAvailableOnMap;

    this.smsModuleExpiration = this.vetClinic.smsModuleExpiration;
    this.vetineoStartDate = this.vetClinic.vetineoStartDate;

    if (this.vetClinic?.paymentLinkAppointmentsQueryDays) {
      this.paymentLinkAppointmentsQueryDays = this.vetClinic.paymentLinkAppointmentsQueryDays;
    }

    if (this.vetClinic?.markInvoicesIssuedToReceipt) {
      this.markInvoicesIssuedToReceipt = this.vetClinic.markInvoicesIssuedToReceipt;
    }

    if (this.paymentsEnabled) {
      this.reservationCancellationRefund = this.vetClinic.reservationCancellationRefund;
    }

    if (!this.vetClinic.legalVer || this.vetClinic.legalVer === 'V1') {
      this.legalVersion = false;
    } else {
      this.legalVersion = true;
    }

    if (this.vetClinic.dateSinceSyncVisitStarted) {
      this.startSyncDate = new Date(new Date(this.vetClinic.dateSinceSyncVisitStarted).getTime() + 7200000).toISOString();
    }

    this.hours = [];

    for (let i = 0; i < 24; i++) {
      this.hours.push(i);
    }


    this.daysForLinks = [];

    for (let i = 1; i <= 21; i++) {
      this.daysForLinks.push(i);
    }

    this.linkedReservationDoctors = this.vetClinic.team?.filter(e => e.hasLinkedReservation);
    if (this.isGeneralAdmin || this.isGeneralClinicAdmin) {
      this.vetClinicGroup = this.formBuilder.group({
        homeImageUUID: [this.vetClinic.homeImageUUID],
        vMsgDefaultImg: [this.vetClinic.vMsgDefaultImg],
        servicesJson: [this.vetClinic.services],
        sendTechnicalAlerts: [this.vetClinic.sendTechnicalAlerts],
        holidaysCheckSyncAllowed: [this.vetClinic.holidaysCheckSyncAllowed],
        technicalAlertsEmail: [this.vetClinic.technicalAlertsEmail, Validators.email],
        hoursToSendReminder: [this.vetClinic.hoursToSendReminder],
        invoiceOfficeEmail: [this.vetClinic.invoiceOfficeEmail, Validators.email],
        percentageRefundValueAfterExpiration: [this.vetClinic.percentageRefundValueAfterExpiration],
        voucherSellInfo: [this.vetClinic.voucherSellInfo],
        paymentsEnabled: [this.vetClinic.paymentsEnabled],
        messagesEnabled: [this.vetClinic.messagesEnabled],
        voucherInfoFirstInSubject: [this.vetClinic.voucherInfoFirstInSubject],
        vetineoPromotionEmailAddon: [this.vetClinic.vetineoPromotionEmailAddon],
        sendConfirmNotification: [this.vetClinic.sendConfirmNotification],
        visitSyncDelayMinutes: [this.vetClinic.visitSyncDelayMinutes],
        visitSyncHour: [this.vetClinic.visitSyncHour, timeValidator],
        refundInfoEmail: [this.vetClinic.refundInfoEmail, Validators.email],
      });
    } else {
      this.vetClinicGroup = this.formBuilder.group({
        homeImageUUID: [this.vetClinic.homeImageUUID],
        vMsgDefaultImg: [this.vetClinic.vMsgDefaultImg],
        servicesJson: [this.vetClinic.services],
        sendTechnicalAlerts: [this.vetClinic.sendTechnicalAlerts],
        holidaysCheckSyncAllowed: [this.vetClinic.holidaysCheckSyncAllowed],
        technicalAlertsEmail: [this.vetClinic.technicalAlertsEmail, Validators.email],
        hoursToSendReminder: [this.vetClinic.hoursToSendReminder],
        invoiceOfficeEmail: [this.vetClinic.invoiceOfficeEmail, Validators.email],
        percentageRefundValueAfterExpiration: [this.vetClinic.percentageRefundValueAfterExpiration],
        voucherSellInfo: [this.vetClinic.voucherSellInfo],
        voucherInfoFirstInSubject: [this.vetClinic.voucherInfoFirstInSubject],
        vetineoPromotionEmailAddon: [this.vetClinic.vetineoPromotionEmailAddon],
        sendConfirmNotification: [this.vetClinic.sendConfirmNotification],
        visitSyncDelayMinutes: [this.vetClinic.visitSyncDelayMinutes],
        visitSyncHour: [this.vetClinic.visitSyncHour, timeValidator],
        refundInfoEmail: [this.vetClinic.refundInfoEmail, Validators.email],
      });
    }

    this.blockReservationsNotInWorkHours = this.vetClinic.blockReservationsNotInWorkHours;
    this.blockReservationsBeforeHour = this.vetClinic.blockReservationsBeforeHour;
    this.blockReservationsAfterHour = this.vetClinic.blockReservationsAfterHour;

    if (this.vetClinic.blockReservationsNotInWorkHours) {
      this.blockReservationsNotInWorkHoursWasSet = true;
    }


    if (this.vetClinic?.services) {
      this.services = JSON.parse(this.vetClinic.services);
      this.servicesItems = JSON.parse(this.vetClinic.services);
    } else {
      this.services = [];
    }

    this.vImagesSub = this.fileService.getVImages(false, this.vetClinic?.vetcodeId.toString())
      .subscribe(images => {
        this.vImages = images;
      });
    this.vc = JSON.parse(JSON.stringify(this.vetClinic));

    if (this.vetClinic.isOldRecommendationsSyncBlocked != null) {
      this.isOldRecommendationsSyncBlocked = this.vetClinic.isOldRecommendationsSyncBlocked;
    }

    this.addCancellationHoursToMail = this.vetClinic.addCancellationHoursToMail;


    if (this.vetClinic.isOldLabTestDataBlocked != null) {
      this.isOldLabTestDataBlocked = this.vetClinic.isOldLabTestDataBlocked;
    }

    if (this.vetClinic?.showAllFreeTerms === null || this.vetClinic?.showAllFreeTerms === undefined) {
      this.showAllFreeTerms = true;
    } else {
      this.showAllFreeTerms = this.vetClinic.showAllFreeTerms;
    }

    if (this.vetClinic?.disableCheckKlinikaXpSync) {
      this.disableCheckKlinikaXpSync = true;
    } else {
      this.disableCheckKlinikaXpSync = false;
    }

    if (this.vetClinic.useBookingHoursForCheckHoursList == null || this.vetClinic.useBookingHoursForCheckHoursList == true) {
      this.useBookingHoursForCheckHoursList = true
    } else {
      this.useBookingHoursForCheckHoursList = false;
    }

    if (this.vetClinic.sendExtendedNotifications != null) {
      this.isSendExtendedNotifications = this.vetClinic.sendExtendedNotifications;
    }

    if (this.vetClinic.delayLabTestDataAcceptationSync != null) {
      this.delayLabTestDataAcceptationSync = this.vetClinic.delayLabTestDataAcceptationSync;
    }

    if (this.vetClinic.sendEmailAboutCrmSmsModuleExpiration != null) {
      this.sendEmailAboutCrmSmsModuleExpiration = this.vetClinic.sendEmailAboutCrmSmsModuleExpiration;
    }

    if (this.vetClinic.labTestDataAcceptationSyncDelayInHours != null) {
      this.labTestDataAcceptationSyncDelayInHours = this.vetClinic.labTestDataAcceptationSyncDelayInHours;
    }

    if (this.vetClinic.sendVisitTypeAdditionalInfo != null) {
      this.sendVisitTypeAdditionalInfo = this.vetClinic.sendVisitTypeAdditionalInfo;
    }
    if (this.vetClinic.visitUpdateSyncPushBlock != null) {
      this.visitUpdateSyncPushBlock = this.vetClinic.visitUpdateSyncPushBlock;
      if (this.visitUpdateSyncPushBlock) {
        this.visitUpdateSyncPushBlockValue = this.vetClinic.visitUpdateSyncPushBlockValue;
      }
    }

    if (this.vetClinic.visitUpdateSyncPushBlockAfter != null) {
      this.visitUpdateSyncPushBlockAfter = this.vetClinic.visitUpdateSyncPushBlockAfter;
      if (this.visitUpdateSyncPushBlockAfter) {
        this.visitUpdateSyncPushBlockValueAfter = this.vetClinic.visitUpdateSyncPushBlockValueAfter;
      }
    }

    if (this.vetClinic.visitSyncHourMode != null) {
      this.visitSyncHourMode = this.vetClinic.visitSyncHourMode;
    }

    this.labTestDataDuringPreparationText = this.vetClinic.labTestDataDuringPreparationText;

    this.appStateService.updateIsBusySubject(false);
  }

  reorderServices(event: CustomEvent<ItemReorderEventDetail>) {
    this.services = this.commonUtils.immutableArrayMove(this.services, event.detail.from, event.detail.to);
    this.servicesItems = this.commonUtils.immutableArrayMove(this.servicesItems, event.detail.from, event.detail.to);
    this.vetClinicGroup.get('servicesJson').setValue(JSON.stringify(this.servicesItems));
    this.markUnsavedChanges();
    event.detail.complete();
  }

  isFormFieldInvalid(form: FormGroup, fieldName: string, validationType: string) {
    return this.commonUtils.isFormFieldInvalid(form, fieldName, validationType);
  }

  onBlockReservationsBeforeHourChange($event: any) {
    if ($event.detail.value) {
      this.markUnsavedChanges();
      if (this.blockReservationsAfterHour) {
        if (+$event.detail.value >= this.blockReservationsAfterHour) {
          this.blockReservationsBeforeHour = null;
          this.commonUtils.presentAlertToast('Podana godzina musi być mniejsza niż godzina po której działa blokowanie rezerwacji')
        } else {
          this.blockReservationsBeforeHour = +$event.detail.value;
        }
      } else {
        this.blockReservationsBeforeHour = +$event.detail.value;
      }

    }
  }

  onBlockReservationsAfterHourChange($event: any) {
    if ($event.detail.value) {
      this.markUnsavedChanges();
      if (this.blockReservationsBeforeHour) {
        if (+$event.detail.value <= this.blockReservationsBeforeHour) {
          this.blockReservationsAfterHour = null;
          this.commonUtils.presentAlertToast('Podana godzina musi być większa niż godzina do której działa blokowanie rezerwacji')
        } else {
          this.blockReservationsAfterHour = +$event.detail.value;
        }
      } else {
        this.blockReservationsAfterHour = +$event.detail.value;
      }
    }
  }

  async openImageDropForPhoto(formControlName: 'homeImageUUID', imageFolder: string) {
    const modal = await this.modalController.create({
      component: VImageDropComponent,
      componentProps: {
        'multiple': false,
        'vetClinicUUID': this.vetClinic.uuid,
        'imageFolder': imageFolder
      }
    });

    modal.onDidDismiss<VImage>().then((dismissData) => {
      if (dismissData && dismissData.data !== null) {
        if (formControlName === 'homeImageUUID') {
          this.vetClinic.homeImage = dismissData.data;
        }

        if (this.images) {
          this.images.push(dismissData.data);
        } else {
          this.images = [];
          this.images.push(dismissData.data);
        }

        this.vetClinicGroup.get(formControlName).setValue(dismissData.data?.uuid);
        this.markUnsavedChanges();
      }
    });

    return await modal.present();
  }

  changePartner(uuid: string) {
    this.partnerUUID = uuid;
    this.partnerToChange = this.partners?.filter(e => e.uuid === uuid)[0];
  }

  onPartnerAction() {
    this.addPartner = !this.addPartner;
    if (this.addPartner) {
      this.partnerAction = 'anuluj przypisywanie partnera'
    } else {
      this.partnerAction = 'przypisz partnera'
    }
  }


  revertImage(valueToRevert: string, image: VImage) {
    if (valueToRevert === 'vMsgDefaultImg') {
      this.vetClinic.vMsgDefaultImgUUID = this.vc.vMsgDefaultImgUUID;
      this.vetClinic.vMsgDefaultImg = this.vc.vMsgDefaultImg;
    }
    if (valueToRevert === 'homeImage') {
      this.vetClinic.homeImageUUID = this.vc.homeImageUUID;
      this.vetClinic.homeImage = this.vc.homeImage;
    }

    if (this.images) {
      this.images = this.images.filter(e => e.uuid !== image.uuid);
    }
  }

  onCancelEdit() {
    if (this.images && this.images.length > 0) {
      console.log(this.images);
      this.markUnsavedChanges();
    }
    if (this.hasUnsavedChanges) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany, czy na pewno chcesz zrezygnować z edycji kliniki?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.cancelVetClinicEditedEmitter.emit(true);
        this.hasUnsavedChanges = false;
      }, () => {
      });
    } else {
      this.commonUtils.presentYesNoActionSheet('Czy na pewno chcesz zrezygnować z edycji kliniki?', 'Tak', 'Nie', 'checkmark-outline', 'close', () => {
        this.cancelVetClinicEditedEmitter.emit(true);
        this.hasUnsavedChanges = false;
      }, () => {
      });
    }
  }

  reorderImage(event: CustomEvent<ItemReorderEventDetail>) {
    this.vetClinicGallery = this.commonUtils.immutableArrayMove(this.vetClinicGallery, event.detail.from, event.detail.to);
    this.markUnsavedChanges();
    event.detail.complete();
  }

  removeImage(idx: number) {
    if (this.vetClinicGallery[idx] !== undefined) {
      this.commonUtils.presentYesNoActionSheet(`Na pewno chcesz usunąć zdjęcie '${(this.vetClinicGallery[idx] as VImage).name}'?`, 'Tak', 'Nie', 'trash', 'close', () => {
        this.vetClinicGallery.splice(idx, 1);
        this.markUnsavedChanges();
      }, () => {
      });
    }
  }

  async addNewImage() {
    const modal = await this.modalController.create({
      component: VImageDropComponent,
      componentProps: {
        'multiple': false,
        'vetClinicUUID': this.vetClinic.uuid,
        'imageFolder': `gallery/${this.commonUtils.generateUUID()}`
      }
    });

    modal.onDidDismiss<VImage>().then((dismissData) => {
      if (dismissData && dismissData.data) {
        (this.vetClinicGallery as VImage[]).push(dismissData.data);
        if (this.images) {
          this.images.push(dismissData.data);
        } else {
          this.images = [];
          this.images.push(dismissData.data);
        }

        this.markUnsavedChanges();
      }
    });

    return await modal.present();
  }

  addNewService() {
    this.services.push('');
    this.servicesItems.push('');
  }

  onServiceChange(idx: number, event: CustomEvent<InputChangeEventDetail>) {
    if (this.servicesItems[idx] !== undefined) {
      this.servicesItems[idx] = event.detail.value;
      this.vetClinicGroup.get('servicesJson').setValue(JSON.stringify(this.servicesItems));
      this.markUnsavedChanges();
    }
  }

  removeService(idx: number) {
    if (this.servicesItems[idx] !== undefined) {
      this.commonUtils.presentYesNoActionSheet(`Na pewno chcesz usunąć usługę '${this.servicesItems[idx]}'?`, 'Tak', 'Nie', 'trash', 'close', () => {
        this.servicesItems.splice(idx, 1);
        this.services.splice(idx, 1);
        this.vetClinicGroup.get('servicesJson').setValue(JSON.stringify(this.servicesItems));
        this.markUnsavedChanges();
      }, () => {
      });
    }
  }

  async addVMsgDefaultImage() {
    const modal = await this.modalController.create({
      component: VImageDropComponent,
      componentProps: {
        'multiple': false,
        'vetClinicUUID': this.vetClinic.uuid,
        'imageFolder': 'v-msg-default'
      }
    });

    modal.onDidDismiss<VImage>().then((dismissData) => {
      if (dismissData && dismissData.data !== undefined && dismissData.data.uuid) {

        this.vetClinic.vMsgDefaultImg = dismissData.data;
        this.vetClinic.vMsgDefaultImgUUID = dismissData.data.uuid;
        // this.markUnsavedChanges();
        this.vetClinicGroup.get('vMsgDefaultImg').setValue(dismissData.data);

        if (this.images) {
          this.images.push(dismissData.data)
        } else {
          this.images = [];
          this.images.push(dismissData.data)
        }
      }
    });

    return await modal.present();
  }


  toggleAdvancedSetting() {
    if (this.advancedSettingsOpened) {
      this.advancedSettingsOpened = false;
    } else {
      this.advancedSettingsOpened = true;
    }
  }

  getAdvanceSettingsButtonIcon() {
    if (this.advancedSettingsOpened) {
      return 'chevron-up-outline';
    } else {
      return 'chevron-down-outline';
    }
  }


  log() {
    console.log(this.paymentLinkAppointmentsQueryDays)
  }

  protected markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChangesEmitter.emit(true);
      this.hasUnsavedChanges = true;
    }
  }

  onSave() {
    if (!this.visitSyncHourMode) {
      this.vetClinicGroup.removeControl('visitSyncHour');
    }

    if (this.paymentsEnabled && (this.reservationCancellationRefund === null || this.reservationCancellationRefund < 0)) {
      this.commonUtils.presentAlertToast("Proszę uzupełnić procent z kwoty vouchera do potrącenia przy standardowych");
      return;
    }

    if (!this.allSpecies && (!this.petSpecies || this.petSpecies.length === 0)) {
      this.commonUtils.presentAlertToast("Proszę podać obsługiwane gatunki zwierząt");
      return;
    }

    console.log(this.vetClinicGroup.valid)
    console.log(this.vetClinicGroup.controls)
    if (this.vetClinicGroup.valid) {
      if (this.vrAutoLockEndHour) {
        if (!this.isHour(this.vrAutoLockEndHour)) {
          this.vetClinicGroup.markAllAsTouched();
          this.commonUtils.presentAlertToast("Proszę poprawić godzinę automatycznej blokady rezerwacji porannych - np: 10:00");
          return;
        }
      } else {
        if (this.vrAutoLockMode) {
          this.vetClinicGroup.markAllAsTouched();
          this.commonUtils.presentAlertToast("Proszę poprawić godzinę automatycznej blokady rezerwacji porannych - np: 10:00");
          return;
        }
      }

      if (this.blockReservationsNotInWorkHours) {
        if (!this.blockReservationsAfterHour && !this.blockReservationsBeforeHour) {
          this.commonUtils.presentAlertToast('Proszę podać godzinę przed którą, oraz po której nie wysłać rezerwacji do użytkowników aplikacji');
          return;
        } else {
          if (this.blockReservationsBeforeHour >= this.blockReservationsAfterHour) {
            this.commonUtils.presentAlertToast('Godzina przed którą nie wysłać rezerwacji do użytkowników aplikacji musi być wcześniejsza niż ta po której nie przesyłać');
            return;
          }
        }
      }

      if (this.delayLabTestDataAcceptationSync) {
        if (!this.labTestDataAcceptationSyncDelayInHours || !this.labTestDataDuringPreparationText) {
          this.commonUtils.presentAlertToast('W przypadku włączonego trybu potwierdzania wyników badań uzupełnij po ilu godzinach wysyłać je automatycznie i jaka treść powinna być wyświetlana w aplikacji');
          return;
        }
      }


      let visitTypesOk = true;

      if (visitTypesOk) {
        this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie', 'checkmark-outline', 'close', () => {
          let vetClinicEdited: VetClinic = this.commonUtils.formGroupValuesToObject<VetClinic>(new VetClinic(), this.vetClinicGroup);
          this.appStateService.updateIsBusySubject(true);

          this.vetClinic.homeImageUUID = vetClinicEdited.homeImageUUID;
          this.vetClinic.servicesJson = JSON.stringify(this.servicesItems);
          this.vetClinic.sendTechnicalAlerts = vetClinicEdited.sendTechnicalAlerts;
          this.vetClinic.technicalAlertsEmail = vetClinicEdited.technicalAlertsEmail;
          this.vetClinic.hoursToSendReminder = vetClinicEdited.hoursToSendReminder;
          this.vetClinic.invoiceOfficeEmail = vetClinicEdited.invoiceOfficeEmail;
          this.vetClinic.percentageRefundValueAfterExpiration = vetClinicEdited.percentageRefundValueAfterExpiration;
          this.vetClinic.holidaysCheckSyncAllowed = vetClinicEdited.holidaysCheckSyncAllowed;
          this.vetClinic.addCancellationHoursToMail = this.addCancellationHoursToMail;
          this.vetClinic.refundInfoEmail = vetClinicEdited.refundInfoEmail;

          this.vetClinic.delayPrepaidReservationFromClinic = this.delayPrepaidReservationFromClinic;
          this.vetClinic.delayReservationFromClinic = this.delayReservationFromClinic;

          if (this.isGeneralAdmin || this.isGeneralClinicAdmin) {
            this.vetClinic.paymentsEnabled = this.paymentsEnabled;
            this.vetClinic.messagesEnabled = this.messagesEnabled;
          }

          if (this.legalVersion) {
            this.vetClinic.legalVer = 'V2';
          } else {
            this.vetClinic.legalVer = 'V1';
          }

          this.vetClinic.vetVisitTypes = null;

          if (this.delayLabTestDataAcceptationSync != null) {
            this.vetClinic.delayLabTestDataAcceptationSync = this.delayLabTestDataAcceptationSync;
          }

          if (this.sendEmailAboutCrmSmsModuleExpiration != null) {
            this.vetClinic.sendEmailAboutCrmSmsModuleExpiration = this.sendEmailAboutCrmSmsModuleExpiration;
          }


          if (this.vetineoStartDate != null) {
            this.vetClinic.vetineoStartDate = this.vetineoStartDate;
          }


          if (this.labTestDataAcceptationSyncDelayInHours != null) {
            this.vetClinic.labTestDataAcceptationSyncDelayInHours = this.labTestDataAcceptationSyncDelayInHours;
          }

          if (this.reservationCancellationRefund) {
            this.vetClinic.reservationCancellationRefund = this.reservationCancellationRefund;
          }
          this.vetClinic.showAllFreeTerms = this.showAllFreeTerms;

          if (this.petSpecies && this.petSpecies?.length > 0 && !this.allSpecies) {
            this.vetClinic.allPetSpecies = false;
            const petSpeciesKeys = this.petSpecies.map(e => e.key);
            this.vetClinic.servedPetSpeciesKeys = JSON.stringify(petSpeciesKeys)
          }

          if (this.allSpecies) {
            this.vetClinic.allPetSpecies = true;
            this.vetClinic.servedPetSpeciesKeys = '[]';
          }


          this.vetClinic.blockReservationsNotInWorkHours = this.blockReservationsNotInWorkHours;
          this.vetClinic.blockReservationsBeforeHour = this.blockReservationsBeforeHour;
          this.vetClinic.blockReservationsAfterHour = this.blockReservationsAfterHour;


          this.vetClinic.voucherInfoFirstInSubject = this.voucherInfoFirstInSubject;
          this.vetClinic.voucherSellInfo = vetClinicEdited.voucherSellInfo;
          this.vetClinic.vetineoPromotionEmailAddon = vetClinicEdited.vetineoPromotionEmailAddon;
          this.vetClinic.sendConfirmNotification = vetClinicEdited.sendConfirmNotification;
          this.vetClinic.visitSyncDelayMinutes = vetClinicEdited.visitSyncDelayMinutes;
          this.vetClinic.visitSyncHour = vetClinicEdited.visitSyncHour;
          this.vetClinic.disableCheckKlinikaXpSync = this.disableCheckKlinikaXpSync;
          this.vetClinic.useBookingHoursForCheckHoursList = this.useBookingHoursForCheckHoursList;
          this.vetClinic.isOffline = this.isOffline;
          this.vetClinic.isAvailableOnMap = this.isAvailableOnMap;
          this.vetClinic.paymentLinkAppointmentsQueryDays = this.paymentLinkAppointmentsQueryDays;

          if (this.startSyncDate != null) {
            this.vetClinic.dateSinceSyncVisitStarted = this.startSyncDate.split('T')[0];
          }

          if (this.isOldRecommendationsSyncBlocked != null) {
            this.vetClinic.isOldRecommendationsSyncBlocked = this.isOldRecommendationsSyncBlocked;
          }

          if (this.markInvoicesIssuedToReceipt != null) {
            this.vetClinic.markInvoicesIssuedToReceipt = this.markInvoicesIssuedToReceipt;
          }

          if (this.isOldLabTestDataBlocked !== null) {
            this.vetClinic.isOldLabTestDataBlocked = this.isOldLabTestDataBlocked;
          }
          if (this.isSendExtendedNotifications !== null) {
            this.vetClinic.sendExtendedNotifications = this.isSendExtendedNotifications;
          }

          if (this.sendVisitTypeAdditionalInfo != null) {
            this.vetClinic.sendVisitTypeAdditionalInfo = this.sendVisitTypeAdditionalInfo;
          }

          if (this.visitUpdateSyncPushBlock != null) {
            this.vetClinic.visitUpdateSyncPushBlock = this.visitUpdateSyncPushBlock;
            if (this.visitUpdateSyncPushBlock) {
              if (this.visitUpdateSyncPushBlockValue !== '') {
                this.vetClinic.visitUpdateSyncPushBlockValue = this.visitUpdateSyncPushBlockValue;
              } else {
                this.vetClinic.visitUpdateSyncPushBlockValue = 1;
              }
            }
          }

          this.vetClinic.smsModuleExpiration = this.smsModuleExpiration + ' 00:00';
          console.log(this.vetClinic.smsModuleExpiration)

          if (this.visitUpdateSyncPushBlockAfter != null) {
            this.vetClinic.visitUpdateSyncPushBlockAfter = this.visitUpdateSyncPushBlockAfter;
            if (this.visitUpdateSyncPushBlockAfter) {
              if (this.visitUpdateSyncPushBlockValueAfter !== '') {
                this.vetClinic.visitUpdateSyncPushBlockValueAfter = this.visitUpdateSyncPushBlockValueAfter;
              } else {
                this.vetClinic.visitUpdateSyncPushBlockValueAfter = 1;
              }
            }
          }

          this.vetClinic.useDifferentVisitTypeTimeInKlinikaXp = this.useDifferentVisitTypeTimeInKlinikaXp;

          if (this.visitSyncHourMode != null) {
            this.vetClinic.visitSyncHourMode = this.visitSyncHourMode;
          }

          if (this.vrAutoLockMode) {
            this.vetClinic.vrAutoLockMode = 1;
          } else {
            this.vetClinic.vrAutoLockMode = 0;
          }

          this.vetClinic.vrAutoLockEndHour = this.vrAutoLockEndHour;

          const galleryImages: VetClinicPhotoGalleryImage[] = (this.vetClinicGallery as VImage[])?.map((vImage, idx) => {
            return new VetClinicPhotoGalleryImage(idx, this.vetClinic.uuid, vImage.uuid);
          });

          this.vetClinic.gallery = galleryImages;

          if (this.addPartner && this.isGeneralAdmin) {
            this.vetClinic.partnerVClientId = this.partnerToChange.id;
          }

          this.vetClinic.labTestDataDuringPreparationText = this.labTestDataDuringPreparationText;

          this.vetClinic.vImagesToSetAsActive = this.images?.map(e => e.uuid)

          // this.vetClinic.vMsgDefaultImgUUID = this.vetClinic.vMsgDefaultImgUUID;
          this.vetClinicService.updateVetClinic(this.vetClinic)
            .subscribe((vc: VetClinic) => {
                this.commonUtils.presentInfoToast("Dane lecznicy zostały zmienione").then(res => {
                });
                this.hasUnsavedChanges = false;
                this.vetClinic = null;
                this.partner = null;
                this.partnerUUID = null;
                this.partnerToChange = null;
                this.partnerAction = 'przypisz partnera';
                this.appStateService.updateIsBusySubject(false);
                this.vetClinicEditedEmitter.emit(vc);
              },
              error => {
                this.appStateService.updateIsBusySubject(false);
                this.commonUtils.presentAlertToast("Wystąpił błąd podczas zmiany danych lecznicy");
              });
        }, () => {
        });
      }
    } else {
      this.vetClinicGroup.markAllAsTouched();
      this.commonUtils.presentAlertToast("Formularz nie jest wypełniony poprawnie")
    }

  }

  changeCalendarValue($event) {
    this.startSyncDate = $event.detail.value;
  }

  getPushBlockLines() {
    return this.visitUpdateSyncPushBlock ? 'none' : 'full';
  }

  getPushBlockClass() {
    if (!this.pushBlockValueRegex.test(String(this.visitUpdateSyncPushBlockValue))) {
      return 'ng-invalid';
    }
    return '';
  }

  getPushBlockAfterClass() {
    if (!this.numberRegexp.test(String(this.visitUpdateSyncPushBlockValueAfter))) {
      return 'ng-invalid';
    }
    return '';
  }

  getLabTestDataAcceptationSyncDelayInHoursClass() {
    if (!this.simpleNumberRegexp.test(String(this.labTestDataAcceptationSyncDelayInHours))) {
      return 'ng-invalid';
    }
    return '';
  }

  pushBlockValueChange($event) {
    const isValid = !$event.detail.value || this.pushBlockValueRegex.test($event.detail.value);
    if (isValid) {
      this.visitUpdateSyncPushBlockValue = $event.detail.value;
    } else {
      if (!this.alertPresented) {
        this.alertPresented = true;
        this.commonUtils.presentAlertToast('Proszę podać liczbę z przedziału od 1 do 8', 3000);
        setTimeout(() => this.alertPresented = false, 3000);
      }
      this.visitUpdateSyncPushBlockValue = 1;
    }
  }


  pushBlockValueAfterChange($event) {
    const isValid = !$event.detail.value || this.numberRegexp.test($event.detail.value);
    if (isValid) {
      this.visitUpdateSyncPushBlockValueAfter = $event.detail.value;
    } else {
      if (!this.alertPresented) {
        this.alertPresented = true;
        this.commonUtils.presentAlertToast('Proszę podać liczbę pełnych godzin', 3000);
        setTimeout(() => this.alertPresented = false, 3000);
      }
      this.visitUpdateSyncPushBlockValueAfter = 1;
    }
  }

  labTestDataAcceptationSyncDelayInHoursValueChange($event) {
    const isValid = !$event.detail.value || this.simpleNumberRegexp.test($event.detail.value);
    if (isValid) {
      this.labTestDataAcceptationSyncDelayInHours = $event.detail.value;
    } else {
      if (!this.alertPresented) {
        this.alertPresented = true;
        this.commonUtils.presentAlertToast('Proszę podać liczbę pełnych godzin', 3000);
        setTimeout(() => this.alertPresented = false, 3000);
      }
      this.labTestDataAcceptationSyncDelayInHours = 1;
    }
    console.log(this.labTestDataAcceptationSyncDelayInHours)
  }

  changePaymentLinkAppointmentsQueryDays($event) {
    if ($event?.detail?.value) {
      this.paymentLinkAppointmentsQueryDays = $event?.detail?.value;
    }
  }

  registerSubscription(sub: Subscription) {
    if (sub) {
      this.subscriptions.add(sub);
    }
  }

  async onSelectSmsCrmModuleExpirationDate() {
    const modal = await this.modalController.create({
      component: SelectSmsCrmModuleExpirationDateComponent,
    });

    modal.onWillDismiss().then(e => {
      if (e && e.data) {
        this.handleSelectedCrmSmsExpirationDate(e.data);
      }
    });

    return await modal.present();
  }

  async onSelectVetineoStartDate() {
    const modal = await this.modalController.create({
      component: GenericSelectDateComponent,
      componentProps: {
        'title': 'Wybierz dzień rozpoczęcia Vetineo'
      }
    });

    modal.onWillDismiss().then(e => {
      console.log(e)
      if (e && e.data) {
        this.vetineoStartDate = e.data;
        console.log(this.vetineoStartDate)
      }
    });

    return await modal.present();
  }


  showLicenceKey() {
    if (!this.vetineoLicenceKey) {
      this.commonUtils.presentYesNoActionSheet('Klucz licencyjny bedzie możliwy do skopiowania tylko za pierwszym pierwszym wyświetleniem. ' +
        'Każde jego następne wyświetlenie będzie zawierało jego wersję częściowo zanonimizowaną. Czy wyświetlić teraz klucz licencyjny?', 'Tak', 'Nie', 'checkmark-outline', 'close', () => {
        this.appStateService.updateIsBusySubject(true);
        this.registerSubscription(this.vetClinicService.getVetineoLicenceKey(this.vetClinic.uuid).subscribe(licenceKeyResp => {
          this.appStateService.updateIsBusySubject(false);
          if (licenceKeyResp) {
            this.vetineoLicenceKeyExpirationDate = licenceKeyResp.exp;
            this.vetineoLicenceKey = licenceKeyResp.key;
          } else {
            this.commonUtils.presentAlertToast('Nie można wyświetlić klucza licencyjnego')
          }
        }, error => {
          switch (error.message) {
            case 'LICENCE_KEY_NOT_EXIST':
              this.commonUtils.presentAlertToast('Brak klucza licencyjnego');
              this.appStateService.updateIsBusySubject(false);
              break;
            default:
              this.commonUtils.presentAlertToast('Nie można wyświetlić klucza licencyjnego')
              this.appStateService.updateIsBusySubject(false);
          }
        }));
      }, () => {
      })
    }
  }

  // createNewLicenceKey() {
  //   this.registerSubscription(this.vetClinicService.checkAllPrepareToGenerateLicenceKey(this.vetClinic.uuid).subscribe(vetineoLicenceStatus => {
  //     if (vetineoLicenceStatus){
  //       if (vetineoLicenceStatus.noErrorsOccured()) {
  //         this.commonUtils.presentYesNoActionSheet('Lecznica poprawnie zweryfikowana. Czy jesteś pewien, że chcesz utworzyć klucz licencyjny co spowoduje konieczną jego aktualizację w klinice XP?',
  //           'Tak', 'Nie', 'checkmark-outline', 'close',
  //           () => {
  //           this.generateNewLicenceKey();
  //           },
  //           () =>{})
  //       }
  //
  //     }
  //
  //   }));
  // }
  //
  // generateNewLicenceKey() {
  // this.appStateService.updateIsBusySubject(true);
  //   this.registerSubscription(this.vetClinicService.createNewVetineoLicenceKey(this.vetClinic.uuid).subscribe(licenceKeyResp => {
  //     this.appStateService.updateIsBusySubject(false);
  //     if (licenceKeyResp) {
  //       this.commonUtils.presentAlertToast('Klucz licencyjny utworzony, wymagana jest jego aktualizacja w klinice XP');
  //     } else {
  //       this.commonUtils.presentAlertToast('Nie można wyświetlić klucza licencyjnego');
  //     }
  //   }, error => {
  //         this.commonUtils.presentAlertToast('Nie można utworzyć klucza licencyjnego');
  //         this.appStateService.updateIsBusySubject(false);
  //   }));
  // }

  getHour(hour: any) {
    let returnString = '';
    if (hour < 10) {
      returnString = returnString.concat('0');
    }
    returnString = returnString.concat(hour.toString());

    returnString = returnString.concat(':00');

    return returnString;
  }

  getBlockReservationsAfterHourClass() {
    if (this.blockReservationsBeforeHour && this.blockReservationsAfterHour) {
      if (this.blockReservationsBeforeHour >= this.blockReservationsAfterHour) {
        return 'ng-invalid';
      } else {
        return '';
      }
    }
    return '';
  }

  getBlockReservationsBeforeHourClass() {
    if (this.blockReservationsBeforeHour && this.blockReservationsAfterHour) {
      if (this.blockReservationsAfterHour <= this.blockReservationsBeforeHour) {
        return 'ng-invalid';
      } else {
        return '';
      }
    }
    return '';
  }

  onChangeReservationCalendarDaySize($event) {
    this.vetClinic.reservationCalendarDaySize = $event.detail.value;
  }

  private handleSelectedCrmSmsExpirationDate(e) {
    this.smsModuleExpiration = e;

  }

  onAllSpeciesChange($event) {
    if ($event.detail.checked) {
      this.tempSpecies = this.petSpecies;
      this.petSpecies = [];
    } else {
      this.petSpecies = this.tempSpecies;
    }
  }

  getSelectedSpeciesText(): string {
    if (!this.petSpecies || this.petSpecies.length === 0) {
      return '';
    }
    return this.petSpecies.map(sp => sp.name).join(', ');
  }

  groupSpecies(): { group: PetSpeciesGroup, species: VetClinicPetSpecies[] }[] {
    const speciesByCode = this.species.reduce((acc, sp) => {
      if (!acc[sp.groupCode]) {
        acc[sp.groupCode] = [];
      }
      acc[sp.groupCode].push(sp);
      return acc;
    }, {} as Record<string, VetClinicPetSpecies[]>);
    const grouped = this.petSpeciesGroups.map(group => ({
      group: group,
      species: speciesByCode[group.code] || []
    }));
    return grouped.sort((a, b) => a.group.orderIdx - b.group.orderIdx);
  }

  async onSelectSpeciesClick() {

    const modal = await this.modalController.create({
      component: SelectSpeciesModalComponent,
      componentProps: {
        petSpecies: this.petSpecies,
        groupedPetSpecies: this.groupedSpecies,
        onModalSave: (updatedSpecies: VetClinicPetSpecies[]) => {
          this.petSpecies = updatedSpecies;
        }
      },
      cssClass: ['stacked-modal', 'wide-modal']
    });

    return await modal.present();
  }

  resetFormGroupControl(controlName: string) {
    this.vetClinicGroup.get(controlName).reset();
  }

  getRefundInfoEmailPlaceholder() {
    return this.vetClinic.clinicMail ? `Wpisz dedykowany email, jeśli inny niż domyślny: ${this.vetClinic.clinicMail}` : "Wpisz dedykowany adres email";
  }
}
